var _desc, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "resources") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Affiliate-quarter-svg-icons",
    transform: "translate(-39.000000, -260.000000)",
    fill: "#585555",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(38.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "resources",
    transform: "translate(1.000000, 210.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 2.723404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.67375887,13.1631206 C4.22036879,13.1631206 2.92765957,12.2326241 2.45832624,10.8473191 L2.42655319,10.742922 C2.31580142,10.3761702 2.26950355,10.0675177 2.26950355,9.75886525 L2.26950355,3.56947518 L0.067177305,10.9208511 C-0.216056738,12.0020426 0.429390071,13.1231773 1.51239716,13.421844 L15.5497305,17.1810496 C15.7249362,17.2264397 15.9001418,17.248227 16.0726241,17.248227 C16.9767943,17.248227 17.8028936,16.6481702 18.034383,15.7639716 L18.8523121,13.1631206 L5.67375887,13.1631206 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17021277,3.63120567 C9.17151773,3.63120567 9.9858156,2.8169078 9.9858156,1.81560284 C9.9858156,0.814297872 9.17151773,0 8.17021277,0 C7.1689078,0 6.35460993,0.814297872 6.35460993,1.81560284 C6.35460993,2.8169078 7.1689078,3.63120567 8.17021277,3.63120567 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.5177305,0 L5.90070922,0 C4.64975887,0 3.63120567,1.01855319 3.63120567,2.26950355 L3.63120567,12.2553191 C3.63120567,13.5062695 4.64975887,14.5248227 5.90070922,14.5248227 L19.5177305,14.5248227 C20.7686809,14.5248227 21.787234,13.5062695 21.787234,12.2553191 L21.787234,2.26950355 C21.787234,1.01855319 20.7686809,0 19.5177305,0 Z M5.90070922,1.81560284 L19.5177305,1.81560284 C19.7682837,1.81560284 19.9716312,2.01895035 19.9716312,2.26950355 L19.9716312,8.71398582 L17.1038865,5.36782979 C16.799773,5.01106383 16.3594894,4.82042553 15.8865248,4.80953191 C15.4162837,4.81225532 14.9750922,5.02104965 14.6737021,5.38235461 L11.3021277,9.42933333 L10.2036879,8.33361702 C9.58275177,7.71268085 8.57236879,7.71268085 7.95234043,8.33361702 L5.44680851,10.8382411 L5.44680851,2.26950355 C5.44680851,2.01895035 5.65015603,1.81560284 5.90070922,1.81560284 Z",
    id: "Shape"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.7e5326dfbeeebb82b2fbd49d0f09a26d.svg";
export { ForwardRef as ReactComponent };